import { ReactNode } from "react";
import * as C from "./styles";
import Header from "../../components/general components/Header";
import Footer from "../../components/general components/Footer";
import ProfilePhoto from "../../assets/images/perfil.jpg";
import { motion, AnimatePresence } from "framer-motion";
import Projects from "../../components/Projects/index";
import { SiHtml5 } from "react-icons/si";
import { SiCss3 } from "react-icons/si";
import { SiJavascript } from "react-icons/si";
import { SiReact } from "react-icons/si";
import { SiNodedotjs } from "react-icons/si";
import { SiTypescript } from "react-icons/si";
import { SiDocker } from "react-icons/si";
import { SiGit } from "react-icons/si";
import { SiGithub } from "react-icons/si";
import { SiPostgresql } from "react-icons/si";
import { SiMysql } from "react-icons/si";
import { SiExpress } from "react-icons/si";
import { SiVisualstudiocode } from "react-icons/si";
import { GiBrazilFlag } from "react-icons/gi";
import { RiEnglishInput } from "react-icons/ri";
import { BsGearFill } from "react-icons/bs";

const Home = () => {
  return (
    <>
      <Header />
      <C.Container>
        <C.Presentation>
          <AnimatePresence>
            <motion.div
              initial={{ y: -300, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 300, opacity: 0 }}
              transition={{ duration: 1.5 }}
            >
              <C.DivInformation>
                <img
                  src={ProfilePhoto}
                  alt="Foto de Perfil"
                  className="profilePhoto"
                />
                <h1>Gabriel Oliveira Santos</h1>
                <p>19 Anos</p>
                <h5>Analista de Sistemas</h5>
                <hr />
              </C.DivInformation>
            </motion.div>
          </AnimatePresence>
        </C.Presentation>

        <C.Skills>
          <h1>Minhas Habilidades</h1>
          <C.DivTecnologies>
            <AnimatePresence>
              <motion.div
                initial={{ x: 300, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -300, opacity: 0 }}
                transition={{ duration: 2.0 }}
              >
                <C.Tecnologies>
                  <SiHtml5 className="Icon" />
                  <SiCss3 className="Icon" />
                  <SiJavascript className="Icon" />
                  <SiReact className="Icon" />
                  <SiNodedotjs className="Icon" />
                  <SiTypescript className="Icon" />
                  <SiExpress className="Icon" />
                  <SiPostgresql className="Icon" />
                  <SiMysql className="Icon" />
                  <SiVisualstudiocode className="Icon" />
                  <SiGit className="Icon" />
                  <SiGithub className="Icon" />
                </C.Tecnologies>
              </motion.div>
            </AnimatePresence>
          </C.DivTecnologies>
          <h1>Idiomas</h1>
          <C.DivLenguages>
            <AnimatePresence>
              <motion.div
                initial={{ x: 300, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -300, opacity: 0 }}
                transition={{ duration: 2.0 }}
              >
                <C.Lenguages>
                  <GiBrazilFlag className="Icon" />
                  <RiEnglishInput className="Icon" />
                </C.Lenguages>
              </motion.div>
            </AnimatePresence>
          </C.DivLenguages>
        </C.Skills>
        <C.DivProjects>
          <h1>Meus Projetos</h1>
          <AnimatePresence>
            <motion.div
              initial={{ x: -300, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 300, opacity: 0 }}
              transition={{ duration: 2.5 }}
            >
              <C.Projects>
                <BsGearFill/>
              </C.Projects>
            </motion.div>
          </AnimatePresence>
        </C.DivProjects>

        <Footer />
      </C.Container>
    </>
  );
};

export default Home;
